import { render, staticRenderFns } from "./GrupoSanguineoPage.vue?vue&type=template&id=b0ca6c4e"
import script from "./GrupoSanguineoPage.js?vue&type=script&lang=js&external"
export * from "./GrupoSanguineoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports